import Alpine from 'alpinejs'

window.Alpine = Alpine

/*-------------------------------------------- */
/** Globals */
/*-------------------------------------------- */
import './globals/auth'
import './globals/components-global'
import './globals/_base'
import './globals/header-promo-bar'

/*-------------------------------------------- */
/** Lib */
/*-------------------------------------------- */
import './vendor/jquery.dropdown'

/*-------------------------------------------- */
/** Components */
/*-------------------------------------------- */
import './components/dropdown'
import './components/dropdown-mobile'
import './components/cart-message'

/*-------------------------------------------- */
/** Router */
/*-------------------------------------------- */
import('./router').then((router) => {
  router.init()
  Alpine.start()
})
